export var cfgOptionsPaths = {
  onClick: 'options.onClick',
  onHover: 'options.onHover',
  yTicksCb: 'options.scales.y.ticks.callback',
  xTicksCb: 'options.scales.x.ticks.callback',
  xAfterTickToLabelConversion: 'options.scales.x.afterTickToLabelConversion',
  xGridLinesColor: 'options.scales.x.gridLines.color',
  tooltipTitleCb: 'options.tooltips.callbacks.title',
  tooltipLabelCb: 'options.tooltips.callbacks.label',
  chartType: 'type',
  yMinVal: 'options.scales.y.min',
  yMaxVal: 'options.scales.y.max',
  labelsData: 'data.labels',
  yValStep: 'options.scales.y.ticks.stepSize'
};